import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EquipmentsService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listEquipments(filters = "") {
    return this.http.get(this.api+`/equipamento${filters}`);
  }

  getEquipment(id) {
    return this.http.get(this.api+`/equipamento/${id}`);
  }

  addEquipment(raw) {
    console.log(raw);
    return this.http.post(this.api+`/equipamento`, raw);
  }

  editEquipment(raw) {
    return this.http.put(this.api+`/equipamento`, raw);
  }

}
